module.exports = __webpack_public_path__ + "img/STERiJECT_02_2.34b4c2ea.png";